import { render, staticRenderFns } from "./SlidingCard.vue?vue&type=template&id=4d65b90b&"
import script from "./SlidingCard.vue?vue&type=script&lang=js&"
export * from "./SlidingCard.vue?vue&type=script&lang=js&"
import style0 from "./SlidingCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports